const modalOpener = document.querySelector('.custom-modal-opener')
const newModal = document.querySelector('.custom-modal');
const modalBox = document.querySelector('.modal-box')
const modalClose = modalBox.querySelector('.close')

// modal closing function
const closeModal = () => {
    newModal.style.display = 'none';
    modalBox.style.display = 'none';
};

modalOpener.addEventListener('click', ()=> {
    newModal.style.display = 'block';
    modalBox.style.display = 'block';
})

newModal.addEventListener('click', (event) => {
    if (event.target === newModal) {
        closeModal();
    }
});

modalClose.addEventListener('click', closeModal);